import React, { Component } from "react";
import BlockUi from "../libraries/react-block-ui";

import NavMenu from "../components/NavMenu";
import Footer from "../components/Footer";
import PageHeader from "../components/PageHeader.js";
import { SpinnerConsumer } from "../context/spinner-context";
import { BannerProvider, BannerConsumer } from "../context/banner-context";
import { BACKEND_CONFIG } from "../config/consts";
import crossImg from "../images/xs.svg";
import alertImg from "../images/alert-round.svg";
import successImg from "../images/mask.svg";
import {
  ActivityLogProvider,
  ActivityLogConsumer,
} from "../context/activity-log-context";

import "../styles/service-transactions.scss";
import "../libraries/react-block-ui/style.css";

class PageWrapper extends Component {
  state = {
    isBlocked: false,
  };

  render() {
    var additionalClass = "";
    switch (this.props.backgroundType) {
      case "photo":
        additionalClass = "photo-background";
        break;
      case "home":
        additionalClass = "home-background";
        break;
      case "login":
        additionalClass = "login-background";
        break;
      default:
        additionalClass = "";
    }
    let auth = this.props.allowUnauthorized
      ? false
      : BACKEND_CONFIG.get("auth");

    return (
      <ActivityLogProvider auth={auth}>
        <ActivityLogConsumer>
          {(contextState) => (
            <div className={"app " + additionalClass}>
              <PageHeader
                allowUnauthorized={this.props.allowUnauthorized}
                auth={auth}
                loadUnreadAgencyNotificationsCount={
                  contextState.loadUnreadAgencyNotificationsCount
                }
                clearLoadedAgencyNotifications={
                  contextState.clearLoadedAgencyNotifications
                }
              />
              <BannerProvider>
                <BannerConsumer>
                  {(context) => {
                    let image, bannerClass;
                    if (context.isSuccessBanner) {
                      image = successImg;
                      bannerClass = "success-banner";
                    } else {
                      image = alertImg;
                      bannerClass = "error-banner";
                    }
                    return (
                      <div
                        className={`banner ${bannerClass}`}
                        hidden={!context.isBannerShown}
                      >
                        <div className="message">
                          <img src={image} alt="close" />
                          <span>{context.message}</span>
                        </div>
                        <div
                          className="close-icon"
                          onClick={() => {
                            context.hideBanner();
                          }}
                        >
                          <img src={crossImg} alt="close" />
                        </div>
                      </div>
                    );
                  }}
                </BannerConsumer>
                <div className="page-middle">
                  {this.props.showMenu === true && (
                    <NavMenu id={"menu"} location={this.props.location} />
                  )}
                  <div className={"main-content"}>
                    <div className="router-content-wrapper">
                      <SpinnerConsumer>
                        {(context) => {
                          return (
                            <div className={"router-content"}>
                              <BlockUi
                                blocking={context.isSpinnerShown}
                                // blocking={true}
                                tag="div"
                                loader={
                                  <div className="spinner">
                                    <div className="bounce1" />
                                    <div className="bounce2" />
                                    <div className="bounce3" />
                                  </div>
                                }
                              >
                                {this.props.children}
                              </BlockUi>
                            </div>
                          );
                        }}
                      </SpinnerConsumer>
                    </div>
                    <Footer />
                  </div>
                </div>
              </BannerProvider>
            </div>
          )}
        </ActivityLogConsumer>
      </ActivityLogProvider>
    );
  }
}

export default PageWrapper;
